import {
  Card,
  CardBody,
  Stat,
  StatNumber,
  StatLabel,
  HStack,
  VStack,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: number | string;
  icon: LucideIcon;
  color?: string;
  isLoading?: boolean;
}

export function StatCard({
  title,
  value,
  icon,
  color = "blue",
  isLoading = false,
}: StatCardProps) {
  const textColor = useColorModeValue("gray.600", "gray.300");

  return (
    <Card>
      <CardBody>
        <HStack justify="space-between" align="flex-start">
          <VStack align="flex-start" spacing={2}>
            <Text fontSize="sm" color={textColor} fontWeight="medium">
              {title}
            </Text>
            <Stat>
              <StatNumber fontSize="2xl" fontWeight="bold">
                {isLoading
                  ? "..."
                  : typeof value === "number"
                    ? value.toLocaleString()
                    : value}
              </StatNumber>
            </Stat>
          </VStack>
          <Icon as={icon} boxSize={8} color={`${color}.500`} opacity={0.8} />
        </HStack>
      </CardBody>
    </Card>
  );
}
